export const AGE_OPTIONS = Array.from({ length: 58 }, (_, i) => 18 + i);

export const FILTER_OPTIONS = {
  countries: [
    "Australia",
    "Bahrain",
    "Bangladesh",
    "Canada",
    "Egypt",
    "Fiji",
    "France",
    "Germany",
    "India",
    "Indonesia",
    "Ireland",
    "Jordan",
    "Kenya",
    "Kuwait",
    "Malaysia",
    "Maldives",
    "Morocco",
    "Netherlands",
    "New Zealand",
    "Nigeria",
    "Oman",
    "Pakistan",
    "Qatar",
    "Saudi Arabia",
    "Singapore",
    "South Africa",
    "Sri Lanka",
    "Sweden",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
  ],
  education: [
    "Secondary (10th)",
    "Senior Secondary (12th)",
    "Graduate",
    "Post Graduate",
    "Doctorate",
  ],
  professions: [
    "Accountant",
    "Advocate",
    "Architect",
    "Business Owner",
    "Civil Servant",
    "Doctor",
    "Finance Analyst",
    "Lecturer",
    "Mechanical Engineer",
    "Nurse",
    "Software Engineer",
    "Teacher",
  ],
  maritalStatus: ["Never Married", "Divorced", "Widowed"],
  practices: [
    "Practicing",
    "Moderately Practicing",
    "Less Practicing",
    "Learning / Improving",
    "Sunni Muslim",
    "Shia Muslim",
    "Revert Muslim",
    "Hanafi",
    "Shafi'i",
    "Maliki",
    "Hanbali",
    "Ahle Hadith",
    "Salafi",
    "Deobandi",
    "Tablighi Jamaat",
    "Barelvi",
    "Dawat-e-Islami",
    "Jamaat-e-Islami",
  ],
};

export function calculateAge(dob) {
  if (!dob || !dob.year || !dob.month || !dob.day) return null;
  const now = new Date();
  let age = now.getFullYear() - dob.year;
  const monthDiff = now.getMonth() + 1 - dob.month;
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < dob.day)) {
    age -= 1;
  }
  return age;
}

export function calculateAgeParts(dob) {
  if (!dob || !dob.year || !dob.month || !dob.day) return null;
  const now = new Date();
  let totalMonths =
    (now.getFullYear() - dob.year) * 12 + (now.getMonth() + 1 - dob.month);
  if (now.getDate() < dob.day) totalMonths -= 1;
  if (totalMonths < 0) return null;
  return { years: Math.floor(totalMonths / 12), months: totalMonths % 12 };
}

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export function formatDOB(dob) {
  if (!dob || !dob.year || !dob.month || !dob.day) return "";
  return `${dob.day} ${MONTHS[dob.month - 1]} ${dob.year}`;
}

export function formatHeight(cm) {
  if (!cm) return "";
  const totalInches = Math.round(cm / 2.54);
  return `${Math.floor(totalInches / 12)} ft ${totalInches % 12} in`;
}

export const DEFAULT_FILTERS = {
  lookingFor: "",
  ageFrom: "",
  ageTo: "",
  country: "",
  state: "",
  city: "",
  education: "",
  profession: "",
  maritalStatus: "",
  practice: "",
  heightFrom: "",
  heightTo: "",
};
